export const AvgQuestionAskedGraphData = () => {
  return <div></div>;
};
